import React from 'react';

const SvgLink: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs>
        <clipPath id="link_svg__a">
          <path d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
      <g
        clipPath="url(#link_svg__a)"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M11 15h2a3 3 0 003-3V8a3 3 0 00-3-3H5a3 3 0 00-3 3v4a3 3 0 003 3" />
        <path d="M13 9h-2a3 3 0 00-3 3v4a3 3 0 003 3h8a3 3 0 003-3v-4a3 3 0 00-3-3" />
      </g>
    </svg>
  );
};

export default SvgLink;
